import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner, Breadcrumb } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import './Community.css';
import ThreadCard from './shared/ThreadCard';

export default function CategoryView() {
  const { categorySlug } = useParams();
  const [category, setCategory] = useState(null);
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategoryData = async () => {
      try {
        setLoading(true);
        // Find category ID by slug
        const catRes = await fetch(`${process.env.REACT_APP_BASE_URL || ''}/api/community/categories`);
        const catData = await catRes.json();
        
        let targetCategory = null;
        if (catData.success) {
          targetCategory = catData.categories.find(c => c.slug === categorySlug);
          setCategory(targetCategory);
        }

        if (targetCategory) {
          // Fetch threads for this category
          const threadRes = await fetch(`${process.env.REACT_APP_BASE_URL || ''}/api/community/discussions?communityId=${targetCategory.id}`);
          const threadData = await threadRes.json();
          if (threadData.success) {
            setThreads(threadData.discussions);
          }
        }
      } catch (error) {
        console.error("Error fetching category", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryData();
  }, [categorySlug]);

  if (loading) {
    return (
      <div className="community-container d-flex justify-content-center align-items-center">
        <Spinner animation="border" variant="warning" />
      </div>
    );
  }

  if (!category) {
    return (
      <div className="community-container text-center py-5">
        <h2 className="text-white">Category not found</h2>
        <Link to="/community" className="community-link mt-3 d-inline-block">Return to Community Home</Link>
      </div>
    );
  }

  return (
    <div className="community-container">
      <Container>
        <Breadcrumb className="mb-4">
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/community" }} className="text-warning">
            Community Home
          </Breadcrumb.Item>
          <Breadcrumb.Item active className="text-white">{category.name}</Breadcrumb.Item>
        </Breadcrumb>

        <Row className="mb-4">
          <Col lg={8}>
            <h1 className="text-white mb-2">{category.name}</h1>
            <p className="text-muted">{category.description}</p>
          </Col>
          <Col lg={4} className="text-lg-end">
            <Link 
              to={`/community/new?c=${category.id}`} 
              className="btn btn-warning fw-bold"
            >
              Post in {category.name}
            </Link>
          </Col>
        </Row>

        <Row>
          <Col>
            {threads.length > 0 ? (
              threads.map(thread => (
                <ThreadCard key={thread.id} thread={thread} />
              ))
            ) : (
              <div className="community-card text-center py-5">
                <h4 className="text-muted mb-3">No discussions yet</h4>
                <p className="text-muted">Be the first to start a conversation in {category.name}!</p>
                <Link to={`/community/new?c=${category.id}`} className="btn btn-outline-warning mt-2">
                  Start Discussion
                </Link>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
